export default {
  women: {
    en: 'Women',
  },
  men: {
    en: 'Men',
  },
  howItWorks: {
    en: 'How it works',
  },
}
